
import MobileCheckButton from './MobileCheckButton.jsx';

export default MobileCheckButton;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/MobileFilterBar/MobileCheckButton/index.js